var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.864,
    height: 98.9,
    viewBox: "0 0 133.864 98.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2810.472 -5606.4)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2810.968 5645.351h113.641v55.249a4.2 4.2 0 01-4.2 4.2h-105.236a4.2 4.2 0 01-4.2-4.2h0v-68.987a4.2 4.2 0 014.2-4.2h90.208m-94.412 36.517h113.64",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.004,
    cy: 10.004,
    r: 10.004,
    transform: "translate(2823.323 5673.541)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M2857.601 5678.159h57.813m-57.813 5.386h57.813m-57.813 5.387h57.813"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.778,
    height: 14.304,
    rx: 1.111,
    transform: "translate(2916.72 5624.2)",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2924.001 5613.75h1.215a4.618 4.618 0 014.618 4.618v5.833h0-10.451 0v-5.833a4.618 4.618 0 014.618-4.618z",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.227,
    cy: 19.227,
    r: 19.227,
    transform: "translate(2905.382 5606.9)",
    stroke: "#6e7e9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.7f09e7e1ede8a096e9cdad4c6b85d9c2.svg";
export { ForwardRef as ReactComponent };